<template>
  <v-container fill-height fluid>

    <!--v-select :items="languageoptions" outlined v-model="language" style="position:absolute; right:10px; top:3px; width:120px; z-index: 999">
    </v-select-->
    <v-select :items="languageoptions" outlined v-model="language" @change="updateLanguage"
        style="position:fixed; right:10px; top:3px; width:100px; font-size: 18px; z-index: 999">
    </v-select>

    <h1 class="text-center" style="width: 100%;" v-if="!client_id">Neautorizovaný prístup</h1>

    <v-row class="text-center" justify="center" v-if="client_id">

      <!--v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          Welcome to Telekom
        </h1>

        <p class="subheading font-weight-regular">
          <a
            href="https://www.telekom.sk"
            target="_blank"
          >www.telekom.sk</a>
        </p>
      </v-col-->

      <v-col cols="12" style="max-width: 500px;">

        <!--v-row justify="center">
            <v-col cols="3" sm="3" style="height: 72px;">
                <v-img
                alt="Telekom Logo"
                class="ml-auto"
                contain
                :src="require('@/assets/logos/telekom-1.png')"
                transition="scale-transition"
                height="48"
                style="filter: invert(0%); float: right;"
                v-if="tenant == 'GO' || tenant == 'TMCZ_GO'"
                />
                <v-img
                alt="Digi Logo"
                class="ml-auto"
                contain
                :src="require('@/assets/digi/digi_sk_logo.svg')"
                transition="scale-transition"
                height="48"
                style="filter: invert(0%); float: right;"
                v-if="tenant == 'DIGI'"
                />
            </v-col>
            <v-col cols="3" sm="3" style="height: 72px;">
                <v-img
                alt="VOYO Logo"
                class="ml-auto"
                contain
                :src="require('@/assets/logos/voyo-1.png')"
                transition="scale-transition"
                height="48"
                style="filter: invert(0%); float: left;"
                />
            </v-col>
        </v-row-->

        <v-row class="text-center" justify="center">
            <v-col cols="12" sm="12">
                <div class="d-none d-sm-flex" style="height:64px;"></div>
                <v-img
                    alt="Telekom Voyo Logo"
                    class="ml-auto"
                    contain
                    :src="require('@/assets/logos/telekom-voyo-1.png')"
                    transition="scale-transition"
                    height="58"
                    style="filter: invert(0%); float: center;"
                    v-if="tenant == 'GO' || tenant == 'TMCZ_GO'"
                    />
                    <v-img
                    alt="Voyo Logo"
                    class="ml-auto"
                    contain
                    :src="require('@/assets/logo_voyo.svg')"
                    transition="scale-transition"
                    height="58"
                    style="filter: invert(0%); float: center;"
                    v-if="tenant == 'DIGI'"
                    />
            </v-col>
        </v-row>

        <!--v-row justify="center">
            <v-col cols="12" sm="4">
                <h2 class="mb-3 mt-5" v-if="tenant == 'GO'">{{lang['header_login_go'][language]}}</h2>
                <h2 class="mb-3 mt-5" v-else-if="tenant == 'DIGI'">{{lang['header_login_digi'][language]}}</h2>
                <h2 class="mb-3 mt-5" v-else-if="tenant == 'TMCZ_GO'">{{lang['header_login_tmcz'][language]}}</h2>
                <h2 class="mb-3 mt-5" v-else></h2>
                <hr/>
            </v-col>
        </v-row-->

        <v-row class="text-center" justify="center">
        <v-col cols="12" sm="12">
            <p class="mb-1 heading1 text-center" v-if="tenant == 'GO'">{{print('PARTNER.VOYO.SSO_WEB.LOGIN_TITLE')}}</p>
            <p class="mb-1 heading1 text-center" v-else-if="tenant == 'DIGI'">{{print('PARTNER.VOYO.SSO_WEB.LOGIN_TITLE')}}</p>
            <p class="mb-1 heading1 text-center" v-else-if="tenant == 'TMCZ_GO'">{{print('PARTNER.VOYO.SSO_WEB.LOGIN_TITLE')}}</p>
            <p class="mb-1 heading1 text-center" v-else></p>
            <p class="mb-3 mt-3 heading1 text-center" style="border-bottom: 1px solid rgb(255,255,255,0.3); font-size:1px;">&nbsp;</p>
            <p class="mb-1 heading2 text-center" v-html="$sanitize(print('PARTNER.VOYO.SSO_WEB.LOGIN_DESCRIPTION'))"></p>
        </v-col>
        </v-row>

        <v-row justify="center" v-if="error !== ''">
            <v-col cols="12" sm="12">
                <p class="heading2 mb-0 mt-0" style="background-color: #FF00024D; color: white; border-radius: 5px; margin-top: 20px; padding: 15px 15px 15px 15px;">{{error}}</p>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12" sm="12" class="pt-0 pb-5">
                <v-text-field clearable outlined :placeholder="print('PARTNER.VOYO.SSO_WEB.USERNAME')" hide-details="auto" v-model="username" light background-color="white" color="#6C6C6C"
                    append-icon="mdi-information-outline" @click:append="$router.push({ path: '/howto' })"
                    style="background-color: white;"
                    autocapitalize="off"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row justify="center" style="text-align: left;"  class="pt-0 mt-0 mb-0">
            <v-col cols="12" sm="12" class="pt-0 pb-0 m-0">
                <p class="mt-0 mb-0 links"><router-link to="/howto">{{print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN')}}</router-link></p>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12" sm="12" class="pt-0 pb-5">
                <v-text-field clearable outlined :placeholder="print('PARTNER.VOYO.SSO_WEB.PASSWORD')" hide-details="auto" v-model="password" light background-color="white" color="#6C6C6C"
                    :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showpassword ? 'text' : 'password'" @click:append="showpassword = !showpassword"
                    autocapitalize="off"
                ></v-text-field>
            </v-col>
        </v-row>
        <!--v-row justify="center">
            <v-col cols="12" md="6">
                <v-checkbox
                label="Zapamätať heslo"
                color="#EA0A8E"
                value="blue"
                hide-details
                class="mt-0"
                ></v-checkbox>
            </v-col>
        </v-row-->

        <v-row justify="center" style="text-align: left;"  class="pt-0 mt-0 mb-1">
            <v-col cols="12" sm="12" class="pt-0 m-0">
                <p class="mt-0 mb-0 links"><router-link to="/resetpass">{{print('PARTNER.VOYO.SSO_WEB.FORGOT_PASSWORD')}}</router-link></p>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12" sm="6" class="pt-0 pb-15">
                <v-btn block x-large
                    type="submit"
                    :color="tenantColor"
                    @click="logmein"
                    :disabled="buttondisabled"
                >
                    {{print('PARTNER.VOYO.SSO_WEB.LOGIN_BTN')}}
                </v-btn>
            </v-col>
        </v-row>

      </v-col>
    </v-row>



  </v-container>
</template>

<style scoped>
.heading1 {
    text-align: left;
    font-size: 30px;
    line-height: 1.2;
}
.heading2 {
    text-align: left;
    font-size: 18px;
    line-height: 1.2;
    letter-spacing: 0.7px;
}

.links a {
  /*color: #00A0DE;*/
  color: #e5e02e;
  font-size: 18px
}

.links a.router-link-exact-active {
  color: #e5e02e;
}

.links a:link, a:visited {
  color: #e5e02e;
  text-decoration: none;
}

.links a:hover, a:active {
  color: #e5e02e;
  text-decoration: none;
}

.v-text-field {
    font-size: 1.5em;
    font-weight: 100;
}

.v-btn {
    text-transform: none;
    color: #EBEBEB;
    font-size: 1.5em !important;
    letter-spacing: normal;
}

</style>

<script>
  import { api } from "../main";
  import VueCookies from 'vue-cookies'
  //import HeaderComponent from '../components/HeaderComponent.vue'

  export default {
    name: 'LogIn',

    components: {
        //HeaderComponent
    },

    data: () => ({
        /*languageoptions: ['SK','EN'],*/
        language: 'EN',
        username: '',
        password: '',
        showpassword: false,
        error: '',
        client_id: '',
        redirect_uri: '',
        flow: '',
        tenant: '',
        lang: {
            'button_login': {'SK': 'Prihlásiť', 'CZ': 'Prihlásit', 'EN': 'Log In'},
            'header_login_go': {'SK': 'Prihlásenie do aplikácie Voyo pre zákazníkov Telekom', 'CZ': 'Prihlásenie pre zákazníkov Telekom', 'EN': 'Login for Telekom customers'},
            'header_login_tmcz': {'SK': 'Prihlásenie pre zákazníkov TMCZ', 'CZ': 'Prihlásenie pre zákazníkov TMCZ', 'EN': 'Login for TMCZ customers'},
            'header_login_digi': {'SK': 'Prihlásenie pre zákazníkov Digi', 'CZ': 'Prihlásenie pre zákazníkov Digi', 'EN': 'Login for Digi customers'},
        },
        //strings: {},
        buttondisabled: false
    }),

    props: ['languagestrings', 'toperror'],

    computed: {
        languageoptions() {
            if(this.tenant == 'GO' || this.tenant == 'DIGI') {
                return ['SK','EN'];
            }
            else if(this.tenant == 'TMCZ_GO') {
                return ['CZ','EN'];
            }
            else {
                return ['SK','EN'];
            }
        },
        queryParams() {
            var queryparamsarr = [];
            for (const [key, value] of Object.entries(this.$route.query)) {
                queryparamsarr.push(key + '=' + value);
            }
            return '?' + queryparamsarr.join('&');
        },
        tenantColor() {
            return this.tenant == 'DIGI' ? '#0095DA' : '#EA0A8E'; // '#0095DA'
        }
    },

    methods: {

        goBack() {
            this.$router.go(-1)
        },

        print(input_prop) {
            return api.print(this.languagestrings, input_prop);
        },

        async logmein() {
            this.buttondisabled = true;
            // SAVE LANGUAGE TO COOKIES
            VueCookies.set('language' , this.language, "1h");

            // VALIDATE INPUT
            if(!this.client_id) {
                this.error = "ERROR: missing client_id";
                this.buttondisabled = false;
                return;
            }
            if(!this.flow) {
                this.error = "ERROR: missing flow";
                this.buttondisabled = false;
                return;
            }
            if(this.flow == 'AUTHORIZATION_CODE' && !this.redirect_uri) {
                this.error = "ERROR: missing redirect_uri";
                this.buttondisabled = false;
                return;
            }
            if(!this.username || !this.password) {
                this.error = "Zadajte prosím prihlasovacie meno a heslo."
                this.buttondisabled = false;
                return;
            }

            // CREATE POST DATA
            const data = {
                "loginOrNickname": this.username,
                "password": this.password,
                "client_id": this.client_id,
                "language": this.language
            }

            // HTTP REQUEST
            const options = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: new URLSearchParams(data)
            };
            var res = await api.requestData(api.baseUrl[this.tenant] + '/oauth/internal/login', options);
            
            // REQUEST RESULTS ACTIONS
            if(Object.prototype.hasOwnProperty.call(res, 'status')) {
                if(res.status == 'ok') {
                    VueCookies.set('accessToken' , res.responseBody.accessToken, "1h");
                    VueCookies.set('vopConsent' , res.responseBody.vopConsent, "1h");
                    if(res.responseBody.vopConsent == true) {
                        this.$router.push({ path: '/allowpartner' });
                        //alert("VOP Consent je sice TRUE, ale aj tak otvorim consent, aby ste videli ako consenty vyzeraju. :)");
                        //this.$router.push({ path: '/consents' });
                    }
                    else {
                        this.$router.push({ path: '/consents' });
                    }
                }
                else {
                    if(res.responseStatus == 'ECONNRESET') {
                        this.error = 'Pripojenie na server zlyhalo.';
                    }
                    else {
                        this.error = res.responseBody.error_description;
                    }              
                }
            }
            else {
                this.error = 'Pripojenie na server zlyhalo.';
            }
            this.buttondisabled = false;
        },

        updateLanguage() {
            this.$emit('updateLanguage', this.language);
        }
    },

    created: async function(){
        this.flow = this.$route.query.flow;
        this.client_id = this.$route.query.client_id;
        this.redirect_uri = this.$route.query.redirect_uri;
        this.tenant = this.$route.query.tenant;
        this.language = VueCookies.get('language');
        if(this.tenant.length > 0) {
            if(!this.language || (this.tenant == 'TMCZ_GO' && this.language == 'SK') || (this.tenant != 'TMCZ_GO' && this.language == 'CZ')) {
                if(this.tenant == 'TMCZ_GO') {
                    this.language = 'CZ';
                }
                else {
                    this.language = 'SK';
                }
            }
        }
        else {
            this.language = 'EN';
        }
        VueCookies.keys().forEach((val) => {
            if(val != 'client_id_pkce' && val!= 'client_id_nopkce') {
                VueCookies.remove(val);
            }
        });
        //console.log('query params', this.$route.query)
        for (const [key, value] of Object.entries(this.$route.query)) {
            VueCookies.set(key , value, "1h");
        }
        VueCookies.set('loginPath', this.$route.fullPath);

        if(this.toperror !== '') {
            this.error += ' ' + this.toperror;
            this.error = this.error.trim();
        }
    }
  }
</script>
